__turbopack_export_value__({
  "loader": "Loader-module-scss-module__De3Giq__loader",
  "loader_fixed": "Loader-module-scss-module__De3Giq__loader_fixed",
  "spin": "Loader-module-scss-module__De3Giq__spin",
});
